import WebApiService from "@/services/webapi.service.js";

const state = {
    project_name: "Cressi_rep",
    resources : null,
    message: null,
    TableFilter: null,
    isLoading: false,
    CategoriaSelected: null,
    ScontiListinoAgente:[],
    CheckOutAbilitato: false,
    Reload: false,
    CatalogoSeclected: null,
    TestaFattura: null,
    azienda: null
}

const getters =  {
    getResources: (state) => (lang) => {
        if(state.resources == null){
            let v = localStorage.getItem("res-Cressi");
            if(v != null && v != 'undefined'){
                let res = JSON.parse(v);
                if(res != null)
                    return res[lang];
            }else{
                return [];
            }
        }else{
            return  state.resources[lang];
        }
    },
    getCategoriaSelected: (state) => {
        return state.CategoriaSelected ?? JSON.parse(localStorage.getItem("CategoriaSelected-Cressi"));
    },
    getCatalogoSelected: (state) => {
        return state.CatalogoSeclected ?? JSON.parse(localStorage.getItem("CatalogoSelected-Cressi"));
    },
    getMessageCart: (state) =>{
        if(state.message == null){
            let msg = JSON.parse(localStorage.getItem("msgCart-Cressi"));
            return msg;
        }else{
            return state.message;
        }
    },
    getPagine: (state) => {
        return state.pagine ?? JSON.parse(localStorage.getItem("pagine"));
    },
    getLoader: (state) =>{
        return state.isLoading;
    },
    getScontiListinoAgente: (state) =>{
        return state.ScontiListinoAgente;
    },
    getCheckOutAbilitato: (state) =>{
        return state.CheckOutAbilitato;
    },
    getReload: (state) =>{
        return state.Reload;
    },
    getTestaFattura: (state) =>{
        let v = localStorage.getItem(state.project_name + "TestaFattura");
        if(state.TestaFattura == null || state.TestaFattura == 'undefined'){
            return JSON.parse(v);
        }else{
            return state.TestaFattura
        }
    },
    getAzienda: (state) =>{
        let v = localStorage.getItem(state.project_name + "AziendaSelected");
        if(state.azienda == null || state.azienda == 'undefined'){
            return JSON.parse(v);
        }else{
            return state.azienda;
        }
    }
}

const mutations = {
    setReload: (state, value) =>{
        state.Reload = value;
    },
    setCategoriaSelected: (state, value) => {
        state.CategoriaSelected = value;
        localStorage.setItem("CategoriaSelected-Cressi", JSON.stringify(state.CategoriaSelected));
    },
    setCatalogoSelected: (state, value) => {
        state.CatalogoSeclected = value;
        localStorage.setItem("CatalogoSelected-Cressi", JSON.stringify(state.CatalogoSeclected));
    },
    setResources: (state, resources)  => {
        state.resources = resources;
        localStorage.removeItem("res-Cressi");
        localStorage.setItem("res-Cressi", JSON.stringify(state.resources));
    },
    setMessageCart: (state, message) =>{
        state.message = message;
        localStorage.setItem("msgCart-Cressi", message);
    },
    setPagine: (state, pagine) => {
        state.pagine = pagine;
        localStorage.setItem('pagine', JSON.stringify(state.pagine));
    },
    setLoading: (state, value) =>{
        state.isLoading = value;
    },
    setScontiListinoAgente:(state, value) =>{
        state.ScontiListinoAgente = value;
    },
    setCheckOutAbilitato: (state, value) =>{
        state.CheckOutAbilitato = value;
    },
    setScontoSelected: (state, value) =>{
        state.ScontoSelected = value;
    },
    setTestaFattura: (state, value) =>{
        localStorage.setItem(state.project_name + "TestaFattura", JSON.stringify(value));
        state.TestaFattura = value;
    },
    setAzienda: (state, value) =>{
        localStorage.setItem(state.project_name + "AziendaSelected", JSON.stringify(value));
        state.azienda = value;
    }
}

const actions = {
    getResourcesFromApi: ({commit}, data) => {
        return WebApiService.getRisorse(data.Shop, data.Lang).then(
            (data) => {
                if(data){
                    commit('setResources', data);
                    return true;
                }
                else{
                    return false;
                }
            }
        ).catch(
            error => {return false}
        );
    }
}

export default {
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}